import * as Sentry from '@sentry/browser';
import { initSentry, isAllowUrl, isIgnoreError } from '@/utils/sentry/index';
import Aegis from 'aegis-web-sdk';
import { isProdDomain } from './utils';
import { version } from '../package.json';

const AEGIS_ID = 'lJv33CyLobyb42gWR0';

const isHttps = document.location.protocol === 'https:';

// 到达指定时间点后刷新已打开的页面（获取最新代码/配置）
// 正式：北京时间（UTC+8）2026-10-01 00:00:00
const REFRESH_AT = new Date('2026-10-01T00:00:00+08:00').getTime();
// const REFRESH_AT = new Date('2026-09-18T11:48:00+08:00').getTime();
const scheduleRefreshAt = () => {
  const delay = REFRESH_AT - Date.now();
  // 已过刷新时间点（页面在此之后打开），无需刷新
  if (delay <= 0) return;
  // setTimeout 延迟为 32 位有符号整数，超出会溢出，分段等待
  const MAX_DELAY = 2 ** 31 - 1;
  if (delay > MAX_DELAY) {
    setTimeout(scheduleRefreshAt, MAX_DELAY);
  } else {
    setTimeout(() => {
      window.location.reload();
    }, delay);
  }
};
scheduleRefreshAt();

if ('serviceWorker' in navigator && isHttps) {
  // unregister service worker
  const { serviceWorker } = navigator;
  if (serviceWorker.getRegistrations) {
    serviceWorker.getRegistrations().then((sws) => {
      sws.forEach((sw) => {
        sw.unregister();
      });
    });
  }
  serviceWorker.getRegistration().then((sw) => {
    if (sw) sw.unregister();
  });

  // remove all caches
  /* @ts-ignore add TS check, handle history code */
  if (window.caches && window.caches.keys()) {
    caches.keys().then((keys) => {
      keys.forEach((key) => {
        caches.delete(key);
      });
    });
  }
}

// 初始化 Sentry 监控
initSentry();

// 初始化 aegis
export const aegis = isProdDomain()
  ? new Aegis({
      id: AEGIS_ID, // 上报 id
      uin: '', // 用户唯一 ID（可选）
      reportApiSpeed: true, // 接口测速
      reportAssetSpeed: true, // 静态资源测速
      spa: true, // spa 应用页面跳转的时候开启 pv 计算
      version,
      api: {
        retCodeHandler() {
          return {
            /**
             * isErr 如果是 true 的话，会上报一条 retcode 异常的日志。
             * 腾讯云接口返回码异常的默认判断条件与业务不兼容，修改判断条件（文档：https://cloud.tencent.com/document/product/248/87197#api.retcodehandler.5B.5D
             * 一致为 false，无需上报，自定义上报会记录所有接口的情况（自定义上报位置：src/utils/request/base.ts）
             */
            isErr: false,
            code: 200,
          };
        },
      },
    })
  : null;

/** 全局非 React 错误捕获；因实际使用 event 中的 message 属性，也做了取值兼容处理，此处就标记为 any 类型了 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
window.addEventListener('error', (event: any) => {
  const errMsg = event?.message;
  if (isIgnoreError(errMsg)) {
    return;
  }
  if (!isAllowUrl(window?.location?.origin)) {
    return;
  }

  Sentry?.captureException(event, {
    extra: { type: 'global error catch' },
  });
});

const script = document.createElement('script');
script.src = 'https://turing.captcha.qcloud.com/TCaptcha.js';
script.async = true;
document.body.appendChild(script);
